import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import { Message } from "element-ui";
import Vue from "vue";
import vue2Geocoder from "@pderas/vue2-geocoder";

const registerform = {
  state: () => ({
    dynamicParams: [],
    registerFormList: [],
    currentRegisterForm: {},
    validationErrors: [],
    validationErrorQuestions: [],
    validationQuestionOne: [],
    categoryMiniValidation: [],
    lastFocus: null,
    currentQuestions: [],
    couponValidationOne: [],
    lastFocusLoading: false,
    categoryForm: {
      id: null,
      registrationFormId: null,
      title: null,
      packetLimitations: [],
      isActivePacketLimitations: false,
      isActive: false
    },
    packetForm: {
      id: null,
      categoryID: null,
      stock: null,
      title:null,
      tagID: null,
      stockControl: null,
      price: null,
      basePriceTitle: "Standart",
      priceOptions: [],
      dayRestrictions: [],
      packetType: 0,
      isPublic: false,
      isActive: false
    },
    couponForm: {
      id: null,
      details: null,
      registrationFormId: null,
      title: null,
      count: 1,
      discountType: 1,
      prefix: null,
      suffix: null,
      discount: 10,
      limitPerCoupon: 1,
      isActive: true,
      enableNotifications: false,
      fullName: null,
      email: null,
      packetLimitations: [],
      isActivePacketLimitations: false
    },
    serviceForm: {
      id: null,
      registrationFormId: null,
      title: null,
      details: null,
      price: 0,
      stock: 0,
      isActiveStockControl: false,
      stockControl: 0,
      categoryIds: [],
      attachments: [],
      tags: [],
      packetLimitations: [],
      isActive: false,
      isActivePacketLimitations: false
    },
    wrapperLoading: false,
    packetMiniValidation: {
      id: null,
      validationErrors: []
    },
    serviceMiniValidation: {
      id: null,
      validationErrors: []
    },
    accompayingValidation: []
  }),
  mutations: {
    setDynamicParams(state, payload) {
      state.dynamicParams = payload;
    },
    setCurrentQuestions(state, payload) {
      state.currentQuestions = payload;
    },
    setRegisterFormList(state, payload) {
      state.registerFormList = payload;
    },
    setCurrentRegisterForm(state, payload) {
      state.currentRegisterForm = payload;
    },
    setRegisterFormValidation(state, payload) {
      state.validationErrors = payload;
    },
    setWrapperLoading(state, payload) {
      state.wrapperLoading = payload;
    },
    setMiniValidation(state, payload) {
      state.packetMiniValidation = payload;
    },
    setServiceMiniValidation(state, payload) {
      state.packetMiniValidation = payload;
    },
    setCategoryMiniValidation(state, payload) {
      state.categoryMiniValidation = payload;
    },
    setLastFocused(state, payload) {
      state.lastFocus = payload;
    },
    setLastFocusedLoading(state, payload) {
      state.lastFocusLoading = payload;
    },
    setCouponValidationOne(state, payload) {
      state.couponValidationOne = payload;
    }
  },
  actions: {
    async reminderCouponGroup(store,payload){
      var res = await axios.post('RegistrationForm/CouponGroupSendReminder', {id: payload});
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
    },
    async getDynamicParams(store, payload) {
      var res = await axios.post("RegistrationForm/GetDynamicParams", { ...payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        store.commit("setDynamicParams", res.data.data.items);
      }
    },
    async getQuestionsObject(context, payload) {
      var res = await axios.post("/RegistrationForm/GetQuestions", payload);
      context.commit("setCurrentQuestions", res.data.data.items);
      return res;
    },
    async deletQuestionOne(context, payload) {
      var res = await axios.post("/RegistrationForm/DeleteQuestion", { id: payload });
    },
    async copyQuestionOne(context,payload){
      var res = await axios.post('/RegistrationForm/CopyQuestionObject', {id :payload});
      return res;
    },
    async saveRegistrationFormOrders(context, payload) {
      var res = await axios.post("/RegistrationForm/UpdateOrderNos", { ids: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
    },
    async saveQuestionOne(context, payload) {
      var res = await axios.post("/RegistrationForm/UpdateQuestion", payload);
      context.state.validationQuestionOne = res.data.validationErrors;
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        // context.dispatch('getQuestionsObject', payload);
      }
      return res;
    },
    async savePoliciesForm(context, payload) {
      var res = await axios.post("/RegistrationForm/updateformpolicies", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
      }
      return res;
    },
    async saveQuestionsForm(context, payload) {
      context.state.lastFocusLoading = true;
      var res = await axios.post("/RegistrationForm/AddOrUpdateBulkQuestions", payload);
      context.state.validationErrorQuestions = res.data.validationErrors;
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      context.state.lastFocusLoading = false;
    },
    async getQuestionObject(context, payload) {
      var res = await axios.post("/RegistrationForm/GetQuestionObject", payload);
      if (payload.mainType != 7) {
        if (res.data.alert.hasError) {
          Message.error(res.data.alert.message);
        } else {
          Message.success(res.data.alert.message);
        }
      }

      return res.data.data;
    },
    async setLastFocus(context, payload) {
      context.dispatch("setLastFocused", payload);
    },
    async updateAccompayingPersonSettings(context, payload) {
      var res = await axios.post("/RegistrationForm/UpdateAccompayingPersonSettings", payload);
      context.state.accompayingValidation = res.data.validationErrors;
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
      }
    },
    async registrationCouponGroupList(context, payload) {
      var res = await axios.post("/RegistrationForm/CouponGroupList", { ...payload, skip: (payload.page - 1) * payload.take });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async registrationPacketDelete(context, payload) {
      var res = await axios.post("/RegistrationForm/PacketDelete", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
      }
      return res;
    },
    async registrationServiceDelete(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceDelete", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
      }
      return res;
    },
    async registrationCategoryDelete(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceCategoryDelete", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
      }
      return res;
    },
    async registrationCouponDelete(context, payload) {
      var res = await axios.post("/RegistrationForm/CouponGroupDelete", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
      }
      return res;
    },
    async savePacketOrders(context, payload) {
      var res = await axios.post("/RegistrationForm/PacketUpdateOrderNos", { ids: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
    },
    async saveServiceOrders(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceUpdateOrderNos", { ids: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
    },
    async saveCategoryOrders(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceCategoryUpdateOrderNos", { ids: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
    },
    async saveCouponMini(context, payload) {
      var res = await axios.post("/RegistrationForm/CouponGroupToggleIsActive", { id: payload });
    },
    async savePacketMini(context, payload) {
      var res = await axios.post("/RegistrationForm/PacketUpdateMini", payload);
      var validPayload = {
        id: payload.id,
        validationErrors: res.data.validationErrors
      };
      context.commit("setMiniValidation", validPayload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getCouponGroup(context, payload) {
      var res = await axios.post("/RegistrationForm/CouponGroupGet", payload);
      return res;
    },
    async saveServiceMini(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceUpdateMini", payload);
      var validPayload = {
        id: payload.id,
        validationErrors: res.data.validationErrors
      };

      context.commit("setServiceMiniValidation", validPayload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async saveCategoryMini(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceCategoryUpdateMini", payload);
      var validPayload = {
        id: payload.id,
        validationErrors: res.data.validationErrors
      };

      context.commit("setServiceMiniValidation", validPayload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async addOrUpdateRegisterCoupon(context, payload) {
      var res = await axios.post("/RegistrationForm/CouponGroupAddOrUpdate", payload);
      context.commit("setCouponValidationOne", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterFormOne", payload.registrationFormId);
        context.dispatch("getRegisterForm");
      }
      return res;
    },
    async addOrUpdateRegisterPacket(context, payload) {
      var res = await axios.post("/RegistrationForm/PacketAddOrUpdate", payload);
      context.commit("setRegisterFormValidation", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await context.dispatch("getRegisterFormOne", payload.categoryID);
        await context.dispatch("getRegisterForm");
      }
      return res;
    },
    async addOrUpdateRegisterService(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceAddOrUpdate", payload);
      context.commit("setRegisterFormValidation", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
        context.dispatch("getRegisterForm");
      }
      return res;
    },
    async addOrUpdateRegisterCategory(context, payload) {
      var res = await axios.post("/RegistrationForm/AdditionalServiceCategoryAddOrUpdate", payload);
      context.commit("setRegisterFormValidation", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterFormOne", context.state.currentRegisterForm.id);
        context.dispatch("getRegisterForm");
      }
      return res;
    },
    async saveRegisterFormSettingsInfo(context, payload) {
      var res = await axios.post("/RegistrationForm/UpdateFormSettings", payload);
      context.commit("setRegisterFormValidation", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterFormOne", payload.id);
        context.dispatch("getRegisterForm");
      }
    },
    async saveRegisterFormInfo(context, payload) {
      var res = await axios.post("/RegistrationForm/UpdateFormInfo", payload);
      context.commit("setRegisterFormValidation", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterFormOne", payload.id);
        context.dispatch("getRegisterForm");
      }
      return res;
    },
    async saveRegisterFormPaymentInfo(context, payload) {
      var res = await axios.post("/RegistrationForm/UpdateFormPaymentInfo", payload);
      context.commit("setRegisterFormValidation", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterFormOne", payload.id);
        context.dispatch("getRegisterForm");
      }
      return res;
    },
    async getRegisterForm(context) {
      var res = await axios.post("/RegistrationForm/List");
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.commit("setRegisterFormList", res.data.data.items);
      }
    },
    async createRegisterFormBase(context) {
      var res = await axios.post("/RegistrationForm/Create");
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.dispatch("getRegisterForm");
      }
      return res.data.data.id;
    },
    async getRegisterFormOne(context, payload) {
      var res = await axios.post("/RegistrationForm/Get", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.commit("setCurrentRegisterForm", res.data.data.item);
      }
      return res;
    },
    async getRegisterFormOneQuestion(context, payload) {
      var res = await axios.post("/RegistrationForm/Get", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.commit("setCurrentRegisterForm", res.data.data.item);
      }
      return res;
    },
    async toggleRegistrationFormEnable(context, payload) {
      var res = await axios.post("/RegistrationForm/ToggleEnableRegistration", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterForm");
      }
    },
    async toggleRegistrationFormActive(context, payload) {
      var res = await axios.post("/RegistrationForm/ToggleIsActive", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterForm");
      }
    },
    async deleteRegisterForm(context, payload) {
      var res = await axios.post("/RegistrationForm/Delete", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getRegisterForm");
      }
    },

    
  },
  getters: {
    getRegisterFormList: state => state.registerFormList,
    getCurrentRegisterForm: state => state.currentRegisterForm,
    getRegistrationPacketForm: state => state.packetForm,
    getRegistrationCategoryForm: state => state.categoryForm,
    getRegistrationCouponForm: state => state.couponForm,
    getRegistrationServiceForm: state => state.serviceForm,
    wrapperLoading: state => state.wrapperLoading,
    getPacketValidation: state => state.packetMiniValidation,
    getServiceValidation: state => state.serviceMiniValidation,
    getCategoryValidation: state => state.categoryMiniValidation,
    getQuestionsValidation: state => state.validationErrorQuestions,
    getAccompayingValidation: state => state.accompayingValidation,
    getLastFocus: state => state.lastFocus,
    getLastFocusLoading: state => state.lastFocusLoading,
    getQuestionValidationOne: state => state.validationQuestionOne,
    getCurrentQuestions: state => state.currentQuestions,
    getCouponAddValidation: state => state.couponValidationOne,
    getDynamicParams: state => state.dynamicParams
  }
};
export default registerform;



// WEBPACK FOOTER //
// ./src/store/registerform.js